export const environment = {
    production: false,
    server_root: 'https://manage.gretxp.com'
  };

  export default environment;